<script setup lang="ts">
import type { LogProps } from '@shared/fondof-fn/log/types'

const props = defineProps<LogProps>()

if (import.meta.env.DEV) {
  console[props.level](props.message)
}
</script>

<template><slot /></template>
